import React, { useEffect } from 'react';
import VoxSmythIcons from '../VoxSmythIcons';

/**
 * LogoutHandler — triggers logout on mount and shows a transient "signing out"
 * screen while React Router transitions away.
 */
export const LogoutHandler = ({ logout }) => {
  useEffect(() => {
    console.log('🚪 LogoutHandler: Processing logout...');
    logout();
  }, [logout]);

  return (
    <div
      style={{
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        height: '100vh',
        fontFamily: 'DM Sans, sans-serif',
        color: '#D7B377',
      }}
    >
      <div style={{ textAlign: 'center' }}>
        <VoxSmythIcons.ArrowLeft size={48} color="#D7B377" />
        <p style={{ marginTop: '1rem', fontSize: '1.2rem' }}>Signing out...</p>
      </div>
    </div>
  );
};

/**
 * EnhancedPageWrapper — thin pass-through wrapper that renders the supplied
 * enhanced component with the spread props. Kept as its own component for
 * clarity (and to give us a single place to add cross-cutting page concerns
 * like analytics or suspense boundaries later).
 */
export const EnhancedPageWrapper = ({ enhancedComponent: EnhancedComponent, ...props }) => (
  <EnhancedComponent {...props} />
);
